import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('round-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "19.5",
    transform: "translate(3.313 4)",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }));
});